import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { RankingEntity } from '../../../entity/ranking-entity';
import { Layout } from "antd";
import { getStatReadOrder } from '../../../http/manager';
import { transaction } from "mobx";

const Ranking: React.FC = () => { 
    const [ dataSource, setDataSource ] = useState<RankingEntity[]>([]);
    useEffect(()=> {
        getList();
        return;
    }, [])
    const getList = ()=> {
        getStatReadOrder({}).then((res:any)=> {
            if(res.data.length > 0) {
                const list: RankingEntity[] = [];
                res.data.forEach((item:any, index:number) => {
                    item.key = index + 1;
                    list.push(item);
                })
                transaction(() => {
                    setDataSource(list);
                })
            }
        })
    }
    return (
        <Layout>
            <TableContainer>
                <ul className="table-header-list">
                    <li className="flex1">排名</li>
                    <li className="article">文章名称</li>
                    <li className="flex1">评论量</li>
                    <li className="flex1">阅读量</li>
                </ul>
                <TableBodyContainer>
                    { dataSource.map(item=> {
                        return <ul className="table-body-list" key={item.key}>
                                    <li className={ `flex1 index index${item.key}` }>
                                        <p>{ item.key }</p>
                                    </li>
                                    <li className="article">{ item.title }</li>
                                    <li className="flex1">{ item.commentCount }</li>
                                    <li className="flex1">{ item.readCount }</li>
                                </ul>
                    }) }
                </TableBodyContainer>
            </TableContainer>
        </Layout>
    )
}

export default observer(Ranking);

const TableContainer = styled.div`
    & {
        ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }
        .table-header-list,
        .table-body-list {
            height: 47px;
            display: flex;
            align-items: center;
            background: #FAFAFA;
            box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.06);
            li {
                flex: 1;
                padding: 0 8px;
                font-size: 14px;
                &.flex1 {
                    flex: 0 0 100px;
                    text-align: center;
                }
            }
        }
        .table-body-list {
            background-color: #fff;
            .index {
                margin-top: 14px;
                display: flex;
                justify-content: center;
                p {
                    width: 30px;
                    height: 34px;
                    display: flex;
                    justify-content: center;
                    color: rgba(0,0,0,0.85);
                }
            }
            .index1 {
                p {
                    background: url(${require("../../../image/ranking-bg1.png")}) no-repeat;
                    background-size: 100% 100%;
                    color: rgba(255,255,255,0.85);
                }
            }
            .index2 {
                p {
                    background: url(${require("../../../image/ranking-bg2.png")}) no-repeat;
                    background-size: 100% 100%;
                    color: rgba(255,255,255,0.85);
                }
            }
            .index3 {
                p {
                    background: url(${require("../../../image/ranking-bg3.png")}) no-repeat;
                    background-size: 100% 100%;
                    color: rgba(255,255,255,0.85);
                }
            }
        }
        .article {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
`
const TableBodyContainer = styled.div`
    & {
        height: 348px;
        background-color: #fff;
        overflow-y: auto;
    }
`